/** 리포트 polling 주기 */
export const POLLING_INTERVAL_MS = 5000;

/**
 * 리포트 polling 최대 지속 시간.
 * 안내 문구의 "평균 3분"은 서비스 안내용이므로 충분한 여유를 둔다.
 * 이 시간 안에 완료되지 않으면 실패로 간주하고 polling을 중단한다.
 */
export const POLLING_MAX_DURATION_MS = 15 * 60 * 1000;
